<template>
    <div class="duels-stats">
        <div class="stats-animation">
            <div v-on:click="duelsSetFilterAnimation(duelsFilterAnimation === 'fast' ? 'normal' : 'fast')" class="animation-toggle" v-bind:class="{ 'toggle-active': duelsFilterAnimation === 'fast' }"></div>
            FAST ANIMATION
        </div>
        <div class="stats-info">
            <div class="info-buy">
                YOUR BUY IN
                <IconCoin />
                <div class="buy-value">
                    <span>{{duelsFormatValue(duelsGetStats.bet).split('.')[0]}}</span>.{{duelsFormatValue(duelsGetStats.bet).split('.')[1]}}
                </div>
            </div>
            <div class="info-winnings">
                <span class="gradient-green">POTENTIAL WINNINGS</span>
                <IconCoin />
                <div class="winnings-value">
                    <span>{{duelsFormatValue(duelsGetStats.potential).split('.')[0]}}</span>.{{duelsFormatValue(duelsGetStats.potential).split('.')[1]}}
                </div>
            </div>
            <div class="info-edge">
                HOUSE EDGE
                <div class="edge-value">
                    <span>5</span>.00%
                </div>
            </div>
        </div>
    </div>
</template>

<script>
        import IconCoin from '@/components/icons/IconCoin';
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'DuelsStats',
        methods: {
            ...mapActions([
                'duelsSetFilterAnimation'
            ]),
            duelsFormatValue(value) {
                return parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        },
        computed: {
            ...mapGetters([
                'authUser', 
                'duelsFilterAnimation', 
                'duelsGames'
            ]),
            duelsGetStats() {
                let stats = { bet: 0, potential: 0 };

                for(const game of this.duelsGames) {
                    if(this.authUser.user !== null && game.bets.some((element) => element.user._id === this.authUser.user._id) === true) {
                        let betAmount = 0;
                        let potentialAmount = Math.floor(game.amount * game.playerCount * 0.95);

                        for(const bet of game.bets) {
                            if(this.authUser.user._id === bet.user._id) {
                                betAmount = Math.floor(betAmount + bet.amount);
                                potentialAmount = Math.floor(potentialAmount - bet.amount);
                            }
                        }

                        stats.bet = Math.floor(stats.bet + betAmount);
                        stats.potential = Math.floor(stats.potential + potentialAmount);
                    }
                }

                return stats;
            }
        }
    }
</script>

<style scoped>
    .duels-stats {
        width: 1160px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 30px;
        margin-left: 10px;
        padding: 16px 24px;
        border-radius: 14px;
        background: linear-gradient(135deg, rgba(26, 41, 66, 0.3) 0%, rgba(15, 25, 35, 0.5) 100%);
        border: 1px solid rgba(184, 115, 51, 0.2);
        box-shadow: 
            0 4px 20px rgba(0, 0, 0, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.03);
        backdrop-filter: blur(8px);
    }

    .duels-stats .stats-animation {
        display: flex;
        align-items: center;
        font-family: 'Satoshi', sans-serif;
        font-size: 13px;
        font-weight: 700;
        color: rgba(184, 115, 51, 0.9);
        letter-spacing: 0.5px;
    }

    .duels-stats .animation-toggle {
        width: 52px;
        height: 26px;
        position: relative;
        margin-right: 12px;
        background: rgba(26, 26, 26, 0.8);
        border-radius: 13px;
        border: 2px solid rgba(184, 115, 51, 0.3);
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    .duels-stats .animation-toggle:hover {
        border-color: rgba(184, 115, 51, 0.5);
        box-shadow: 
            inset 0 2px 8px rgba(0, 0, 0, 0.3),
            0 0 12px rgba(184, 115, 51, 0.2);
    }

    .duels-stats .animation-toggle::after {
        content: '';
        width: 20px;
        height: 20px;
        position: absolute;
        top: 1px;
        left: 1px;
        background: linear-gradient(135deg, rgba(184, 115, 51, 0.6) 0%, rgba(184, 115, 51, 0.4) 100%);
        border-radius: 50%;
        transition: all 0.3s ease;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
    }

    .duels-stats .animation-toggle.toggle-active {
        background: rgba(184, 115, 51, 0.15);
        border-color: rgba(184, 115, 51, 0.5);
    }

    .duels-stats .animation-toggle.toggle-active::after {
        left: 27px;
        background: var(--gradient-yellow);
        box-shadow: 0 2px 12px rgba(184, 115, 51, 0.6);
    }

    .duels-stats .stats-info {
        display: flex;
        align-items: center;
        gap: 24px;
    }

    .duels-stats .info-buy,
    .duels-stats .info-winnings,
    .duels-stats .info-edge {
        display: flex;
        align-items: center;
        font-family: 'Satoshi', sans-serif;
        font-size: 12px;
        font-weight: 600;
        color: rgba(184, 115, 51, 0.7);
        padding: 8px 16px;
        border-radius: 10px;
        background: rgba(26, 26, 26, 0.5);
        border: 1px solid rgba(184, 115, 51, 0.15);
        transition: all 0.3s ease;
    }

    .duels-stats .info-buy:hover,
    .duels-stats .info-winnings:hover,
    .duels-stats .info-edge:hover {
        background: rgba(26, 26, 26, 0.7);
        border-color: rgba(184, 115, 51, 0.3);
        box-shadow: 0 0 16px rgba(184, 115, 51, 0.15);
    }

    .duels-stats .info-winnings span {
        font-weight: 700;
        background: var(--gradient-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    .duels-stats .info-buy img,
    .duels-stats .info-winnings img {
        width: 20px;
        height: 20px;
        margin-left: 12px;
        filter: drop-shadow(0 0 4px rgba(184, 115, 51, 0.3));
    }

    .duels-stats .buy-value,
    .duels-stats .winnings-value,
    .duels-stats .edge-value {
        margin-left: 10px;
        font-family: 'Space Grotesk', monospace;
        font-size: 11px;
        font-weight: 600;
        color: rgba(184, 115, 51, 0.6);
    }

    .duels-stats .edge-value {
        margin-left: 12px;
    }

    .duels-stats .buy-value span,
    .duels-stats .winnings-value span,
    .duels-stats .edge-value span {
        font-size: 16px;
        font-weight: 700;
        color: #ffffff;
        text-shadow: 0 0 10px rgba(184, 115, 51, 0.3);
    }

    .duels-stats .winnings-value span {
        background: var(--gradient-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    @media only screen and (max-width: 1180px) {
        .duels-stats {
            width: 100%;
            margin-left: 0;
        }
    }

    @media only screen and (max-width: 950px) {
        .duels-stats {
            flex-direction: column-reverse;
            align-items: flex-start;
            padding: 14px 16px;
            gap: 12px;
        }

        .duels-stats .stats-animation {
            margin-top: 0;
            width: 100%;
            justify-content: center;
        }

        .duels-stats .stats-info {
            width: 100%;
            flex-wrap: wrap;
            gap: 10px;
            justify-content: space-between;
        }
    }

    @media only screen and (max-width: 768px) {
        .duels-stats {
            margin-top: 15px;
            padding: 12px 14px;
            border-radius: 12px;
        }

        .duels-stats .stats-animation {
            font-size: 12px;
        }

        .duels-stats .animation-toggle {
            width: 48px;
            height: 24px;
        }

        .duels-stats .animation-toggle::after {
            width: 18px;
            height: 18px;
        }

        .duels-stats .animation-toggle.toggle-active::after {
            left: 25px;
        }

        .duels-stats .stats-info {
            gap: 8px;
        }

        .duels-stats .info-buy,
        .duels-stats .info-winnings,
        .duels-stats .info-edge {
            flex: 1;
            min-width: 140px;
            padding: 6px 12px;
            font-size: 11px;
        }

        .duels-stats .info-buy img,
        .duels-stats .info-winnings img {
            width: 18px;
            height: 18px;
        }

        .duels-stats .buy-value span,
        .duels-stats .winnings-value span,
        .duels-stats .edge-value span {
            font-size: 14px;
        }
    }

    @media only screen and (max-width: 500px) {
        .duels-stats {
            margin-top: 12px;
            padding: 10px 12px;
            gap: 10px;
        }

        .duels-stats .info-buy,
        .duels-stats .info-winnings,
        .duels-stats .info-edge {
            width: 100%;
            min-width: auto;
            justify-content: flex-start;
            padding: 8px 12px;
        }

        .duels-stats .stats-animation {
            font-size: 11px;
        }

        .duels-stats .animation-toggle {
            width: 44px;
            height: 22px;
        }

        .duels-stats .animation-toggle::after {
            width: 16px;
            height: 16px;
        }

        .duels-stats .animation-toggle.toggle-active::after {
            left: 23px;
        }

        .duels-stats .buy-value span,
        .duels-stats .winnings-value span,
        .duels-stats .edge-value span {
            font-size: 13px;
        }
    }
</style>
